import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ContextService } from 'src/app/services/context.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-file',
	templateUrl: './file.component.html',
	styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {
	@Output() emitUploadedDoc = new EventEmitter<any>();
	@Output() emitUseGeneratedFile = new EventEmitter<any>();

	loadingGeneratedFile = false;

	uploadedDoc: any;
	generatedFileExists = false;
	useGeneratedFile = false;
	cancelGeneratedFile = false;

	showDragDropBorder: boolean = false;

	constructor(
		private contextService: ContextService,
		private procoreService: ProcoreService
	) { }

	ngOnInit() {
		if (this.contextService.clientDetailProcore.useExportedFile) {
			this.retrieveGeneratedFile();
		}
	}

	retrieveGeneratedFile() {
		this.cancelGeneratedFile = false;

		console.log(this.contextService.procoreContextObject.context);
		const exportedFileVeiws = ['prime_contracts.detail', 'prime_contracts.change_orders.detail', 'commitments.work_order_contracts.detail', 'commitments.commitment_contract_change_orders.detail'];
		if (this.contextService.clientDetailProcore.useExportedFile && exportedFileVeiws.indexOf(this.contextService.procoreContextObject.context.view) > -1) {
			this.loadingGeneratedFile = true;
			const fileContext = {
				companyId: this.contextService.procoreContextObject.context.company_id,
				projectId: this.contextService.procoreContextObject.context.project_id,
				itemId: this.contextService.procoreContextObject.context.id
			}

			this.procoreService.downloadGeneratedFile(fileContext, this.contextService.procoreContextObject.context.view, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
				.subscribe((result: any) => {
					if (result) {
						this.generatedFileExists = true;

						this.useGeneratedFile = true;
						this.emitUseGeneratedFile.emit(this.useGeneratedFile);
					}
					this.loadingGeneratedFile = false;
				}, (err) => {
					this.loadingGeneratedFile = false;
				});
		}
	}

	fileUploaded(e: any) {
		if (e.target) {
			this.uploadedDoc = e.target.files[0];
		} else {
			this.uploadedDoc = e[0];
		}
		this.emitUploadedDoc.emit(this.uploadedDoc);

		this.showDragDropBorder = false;
	}

	fileCleared() {
		this.uploadedDoc = null;
		this.emitUploadedDoc.emit(this.uploadedDoc);

		this.useGeneratedFile = false;
		this.emitUseGeneratedFile.emit(this.useGeneratedFile);
	}

	cancelFileGeneration() {
		this.cancelGeneratedFile = true;
		this.loadingGeneratedFile = false;

		this.useGeneratedFile = false;
		this.emitUseGeneratedFile.emit(this.useGeneratedFile);
	}

	selectUseGeneratedPDF() {
		this.cancelGeneratedFile = false;

		this.useGeneratedFile = true;
		this.emitUseGeneratedFile.emit(this.useGeneratedFile);
	}
}
